import Joi from '@hapi/joi'

export const WeighPointWiseDeductionReportSchemaObject = {
    groupID: Joi.number().invalid(0).required().label("Group Name").messages({
        "any.invalid": `Group Name cannot have invalid characters`,
        "any.required": `Group Name is required`
    }),
    estateID: Joi.number().invalid(0).required().label("Estate Name").messages({
        "any.invalid": `Estate Name cannot have invalid characters`,
        "any.required": `Estate Name is required`
    }),
    //date: Joi.string().invalid("").label("Date"),
    fromDate: Joi.string().invalid("").label("From Date"),
    toDate: Joi.string().invalid("").label("To Date"),
    regNumber: Joi.string().allow(null, '').label("Reg Number"),
    divisionID: Joi.number().required().label("Division Name").messages({
        "any.invalid": `Division Name cannot have invalid characters`,
        "any.required": `Division Name is required`
    })
}